const RankingColumns = [
  {
    name: "RANK",
    value: "rank",
    show: true,
    isBold: true,
  },
  {
    name: "INSTITUTE",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "GOVT/PVT",
    value: "institution_type",
    show: true,
    isBold: true,
  },
  {
    name: "ADMISSION ATTRACTIVENESS",
    value: "admission_attractiveness",
    show: true,
    isBold: true,
  },
  {
    name: "AGE & BRAND APPEAL",
    value: "age_and_accreditation",
    show: true,
    isBold: true,
  },
  {
    name: "PLACEMENT & ROI",
    value: "placement_and_roi",
    show: true,
    isBold: true,
  },
  {
    name: "PEDAGOGY & INFRASTRUCTURE",
    value: "pedagogy_and_infrastructure",
    show: true,
    isBold: true,
  },
];

export default RankingColumns;
